import {
  Activity, AlertTriangle, Armchair, Bath, Battery, BatteryCharging, Bed, BedDouble, Bell, Bolt,
  Bot, Briefcase, Brain, Calendar, CarFront, Check, ChevronRight, ChevronLeft, CloudRain, Cloud,
  CookingPot, Cpu, Download, DoorOpen, Droplet, Droplets, Fan, Film, Flame, Footprints, Gauge,
  HardDrive, House, LayoutGrid, Leaf, Lightbulb, ListChecks, Lock, LockOpen, Moon, Music, Network,
  Pause, Play, Plug, Power, RefreshCw, Server, Settings, Shield, ShieldAlert, Shirt, Siren,
  SkipBack, SkipForward, Snowflake, Sofa, Sparkles, Speaker, Sprout, Sun, Sunrise, Sunset,
  Thermometer, ThermometerSun, Trash2, Trees, Tv, User, Users, Volume2, Warehouse, Wifi, WifiOff,
  Wind, Zap, type LucideIcon,
} from 'lucide-react'

const MAP: Record<string, LucideIcon> = {
  activity: Activity, 'alert-triangle': AlertTriangle, bath: Bath, battery: Battery,
  'battery-charging': BatteryCharging, bed: Bed, 'bed-double': BedDouble, bolt: Bolt,
  briefcase: Briefcase, calendar: Calendar, 'car-front': CarFront, check: Check,
  'chevron-right': ChevronRight, 'chevron-left': ChevronLeft, cloud: Cloud, 'cloud-rain': CloudRain,
  'cooking-pot': CookingPot, download: Download, 'door-open': DoorOpen, droplets: Droplets,
  film: Film, flame: Flame, footprints: Footprints, gauge: Gauge, house: House,
  'layout-grid': LayoutGrid, leaf: Leaf, lightbulb: Lightbulb, 'list-checks': ListChecks,
  lock: Lock, 'lock-open': LockOpen, moon: Moon, music: Music, pause: Pause, play: Play,
  plug: Plug, power: Power, 'refresh-cw': RefreshCw, server: Server, settings: Settings,
  shield: Shield, 'shield-alert': ShieldAlert, 'skip-back': SkipBack, 'skip-forward': SkipForward,
  snowflake: Snowflake, sofa: Sofa, speaker: Speaker, sun: Sun, thermometer: Thermometer,
  'thermometer-sun': ThermometerSun, 'trash-2': Trash2, trees: Trees, tv: Tv, user: User,
  users: Users, 'volume-2': Volume2, warehouse: Warehouse, wifi: Wifi, 'wifi-off': WifiOff,
  wind: Wind, zap: Zap,
  armchair: Armchair, bell: Bell, bot: Bot, brain: Brain, cpu: Cpu, droplet: Droplet, fan: Fan,
  'hard-drive': HardDrive, network: Network, shirt: Shirt, siren: Siren, sparkles: Sparkles,
  sprout: Sprout, sunrise: Sunrise, sunset: Sunset,
}

interface IconProps {
  name: string
  size?: number
  className?: string
  strokeWidth?: number
}

export function Icon({ name, size = 22, className, strokeWidth = 1.9 }: IconProps) {
  const Cmp = MAP[name] ?? Bolt
  return <Cmp size={size} className={className} strokeWidth={strokeWidth} aria-hidden />
}

export function hasIcon(name: string): boolean {
  return name in MAP
}
